import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

export const getFileCategories = async type => {
  try {
    const response = await authFetch.get(`/api/Files/CategoriesByEntity?entity=${type}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getFileUploadSourceTypes = async () => {
  try {
    const response = await authFetch.get('/api/Files/FileUploadSourceTypes');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const toggleFilePin = async (fileId) => makeRequest(authFetch.patch(`/api/Files/${fileId}/togglePin`));
